import React, {Fragment} from 'react'
import CommonCounter from './CommonCounter'


const counterContent =[
    {
        num:'125',
        desc:'Orang percaya pada kami',
    },
    {
        num:'185',
        desc:'Pelayanan Memuaskan',
    },
    {
        num:'122',
        desc:'Pengguna aplikasi',
    },
]

const CounterTwo = () => {
    return (
        <Fragment>
            <ul className="list-none count-list">
                {counterContent.map((val,i)=>(
                    <li key={i}>
                        <div className="counter-style-two boder-style d-xxl-flex align-items-center mb-30">
                            <h3><span className="counter"><CommonCounter value={val.num} /></span>+</h3>   
                            <p className="text-white">{val.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </Fragment>
    )
}

export default CounterTwo